import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/healthcare/healthcare-donations";

export const Route = createFileRoute(
  "/admin/_modules/_healthcare/healthcare-donations"
)({
  component: Page,
});
